import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import {multiFactor, RecaptchaVerifier} from "firebase/auth";
import { useAuthContext } from '../../auth/useAuthContext';
// sections
import Login from '../../sections/auth/login/Login';
import MFAEnroll from "../../sections/auth/login/MFAEnroll";
import VerifyCode from "../../sections/auth/login/VerifyCode";
// import Login from '../../sections/auth/LoginAuth0';
// ----------------------------------------------------------------------

export default function LoginPage() {
    const [stage, setStage] = useState("login");
    const { state, currentUserObj, auth} = useAuthContext();
    const [mfaUser, setMFAUser] = useState("");


    function firstSignIn(){

    }

    console.log(state);

    useEffect(()=>{
        console.log(state);
        if(state === "MFA"){
            setStage("MFA");
        } else if (state === "MFAEnroll"){
            setStage("MFAEnroll");
        }
    }, [state])

    useEffect(()=>{

        if(currentUserObj === null || mfaUser !== ''){
            return
        }
        console.log(currentUserObj);
        setMFAUser(multiFactor(currentUserObj));
    }, [currentUserObj])

    useEffect(()=>{
        try{
            window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {'size':'invisible'});
            console.log('loaded recaptcha');
            // setRecaptcha(window.recaptchaVerifier)
        } catch (error){
            console.log(error);
        }  
    }, [])


    return (
        <>
        <Helmet>
            <title> Powertron Global Installs</title>
        </Helmet>
        <div id="recaptcha-container"/>

        {
            stage === "login" &&
            <Login />
        }

        {
            stage === "MFAEnroll" &&
            <MFAEnroll mfaUser={mfaUser}/>
        }

        {
            stage === "MFA" &&
            <VerifyCode />
        }
        </>
    );
}
